<template>
  <div style="padding: 15px">
    <el-input
      v-model="code"
      placeholder="输入字典类型编码"
      style="display: inline-block"
    ></el-input>
    <div style="margin-top: 10px">(例: ZONE:china，AREA_ZONE，POST_TYPE)</div>
    <el-checkbox v-model="multiple" label="是否多选" size="large" />
    <el-button type="primary" @click="showDialog" style="margin-left: 15px">点击</el-button>
    <LsSelectDict
      :show.sync="visible"
      :code="code"
      :dict="dict"
      @submit="submit"
      @close="closeDialog"
    ></LsSelectDict>
  </div>
</template>

<script>
import LsSelectDict from "./index.vue";
export default {
  name: 'LsSelectDictPage',
  components: {
    LsSelectDict
  },
  data() {
    return {
      visible: false,
      code: "",
      multiple: true,
      dict: []
    }
  },
  mounted() {
    this.dict = [];
  },
  methods: {
    showDialog() {
      if (!this.code) {
        return this.$message.error("请输入字典类型编码");
      }
      this.visible = true;
    },

    submit(data) {
      console.log(data);
      let temp = [];
      data.map((item) => {
        temp.push(item.dictItemCode);
      });
      this.dict = temp;
    },

    closeDialog() {
      console.log("关闭弹窗close");
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
